const Statistics = Mach.requireModule('Statistics');
const SLCompass = Mach.requireModule('SLCompass');

const CID = 'c_waimai_c_overseas_dmr0kb7p';
const SKIP_NO_STREET_NUMBER = 1;
const SKIP_NO_ADDITIONAL = 2;

// 当页面存在多个状态时，用来上报区分页面的状态。0=地图选点，1=新增，2=编辑
let pageType = '';
let pageSource = '';
let status = '';
let bizLine = '';
let startTime = 0;
// 地址类型。0-临时选点；1-地址；2-首装流程-地址
let addressType = '';
const reportedMv = new Set();
export function setPageType(type) {
  if (type === 'map') {
    pageType = '0';
    return;
  } else if (type === 'add') {
    pageType = '1';
    return;
  } else if (type === 'edit') {
    pageType = '2';
    return;
  }
  pageType = type;
}

export function setPageSource(soruce) {
  pageSource = soruce;
}

export function setStatus(val) {
  status = val;
}

export function setBizLine(val) {
  bizLine = val;
}

export function setAddressType(scene) {
  if (scene === 0 || scene === 11) {
    addressType = '0';
  } else if (scene === 1 || scene === 2) {
    addressType = '1';
  } else if (scene === 3) {
    addressType = '2';
  }
}

export function setStartTime() {
  startTime = new Date().getTime();
}

function flattenObject(obj: unknown): Record<string, any> {
  const result: Record<string, any> = {};
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
    return result;
  }
  // 类型断言，确保 obj 是 Record 类型
  const safeObj = obj as Record<string, unknown>;

  Object.keys(safeObj).forEach((key) => {
    const value = safeObj[key];
    // 驼峰转换为下划线
    const newKey = key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
    if (value !== null && value !== undefined && typeof value === 'object') {
      // 递归处理嵌套对象
      const nestedResult = flattenObject(value);
      Object.assign(result, nestedResult);
    } else {
      result[newKey] = value;
    }
  });
  return result;
}

interface Value {
  [key: string]: any;
}
const pv = (val: Value = {}) => {
  Statistics?.pv(CID, val);
};
const mv = (bid: string, val: Value = {}) => {
  Statistics?.view(CID, bid, val);
};

const mvNoDuplicateReport = (bid: string, val: Value = {}) => {
  if (reportedMv.has(bid)) {
    // mv事件不能重复上报
    return;
  }
  reportedMv.add(bid);
  Statistics?.view(CID, bid, val);
};

const mc = (bid: string, val: Value = {}) => {
  Statistics?.click(CID, bid, val);
};

const lx = {
  pv() {
    pv({
      page_type: pageType,
      page_source: pageSource
    });
  },
  // 地图选点页返回
  mapBackMc() {
    mc('b_waimai_c_overseas_m3baokqr_mc', {
      biz_line: bizLine,
    });
  },
  // 搜索框聚焦
  searchInputMc() {
    mc('b_waimai_c_overseas_8elu3omd_mc', {
      page_type: pageType,
      biz_line: bizLine,
    });
  },
  // 搜索框曝光
  searchInputMv() {
    mv('b_waimai_c_overseas_8elu3omd_mv', {
      page_type: pageType,
      biz_line: bizLine,
    });
  },
  //搜索框清空
  searchInputClearMc(val) {
    mc('b_waimai_c_overseas_wk71o0oa_mc', {
      ...val,
      page_type: pageType,
      biz_line: bizLine,
    });
  },
  //搜索框取消
  searchInputCancelMc(val) {
    mc('b_waimai_c_overseas_zo2zxhjf_mc', {
      ...val,
      page_type: pageType,
      biz_line: bizLine,
    });
  },
  // 定位到当前位置的图标点击
  focusLocMc() {
    mc('b_waimai_c_overseas_73697bqg_mc', {
      page_type: pageType,
      biz_line: bizLine,
    });
  },
  // 地图拖动，包括点击和手势
  mapDragMc(val) {
    mc('b_waimai_c_overseas_e72wfjp4_mc', {
      page_type: pageType,
      biz_line: bizLine,
      ...val
    });
  },
  // 关联地址曝光埋点
  nearByListMv(val) {
    mv('b_waimai_c_overseas_w6fwfj4m_mv', {
      ...val,
      page_type: pageType,
      biz_line: bizLine,
    });
  },
  // 关联地址确认按钮
  nearBySureMc(val) {
    mc('b_waimai_c_overseas_mkxd3cpw_mc', {
      ...val,
      page_type: pageType,
      biz_line: bizLine,
    });
  },
  // 地址搜索列表曝光
  searchSugMv(val) {
    mv('b_waimai_c_overseas_sytg9yea_mv', {
      ...val,
      page_type: pageType,
      biz_line: bizLine,
    });
  },
  // 地址搜索列表点击
  searchSugMc(val) {
    mc('b_waimai_c_overseas_sytg9yea_mc', {
      ...val,
      page_type: pageType,
      biz_line: bizLine,
    });
  },
  // 地址编辑推出前弹窗
  backPopMv() {
    mv('b_waimai_c_overseas_txw8bpgp_mv', {
      status,
      biz_line: bizLine,
    });
  },
  // 地址编辑推出前弹窗按钮点击
  backPopMc(val) {
    mc('b_waimai_c_overseas_txw8bpgp_mc', {
      ...val,
      status,
      biz_line: bizLine,
    });
  },
  // 地址编辑保存
  saveAddressMc(jsonObj) {
    const newVal = flattenObject(jsonObj);
    mc('b_waimai_c_overseas_ovcfdoxo_mc', {
      ...newVal,
      status,
      duration_time: new Date().getTime() - startTime,
      biz_line: bizLine,
      page_type: pageType,
      address_type: addressType,
      // poi信息补全
      poi_id: newVal.poi_id || '',
      poi_name: newVal.poi_name || '',
      poi_address_name: newVal.poi_address_name || ''
    });
  },
  // 地址编辑关闭页面
  closeAddressMc() {
    mc('b_waimai_c_overseas_uve4qrvo_mc', {
      status,
      biz_line: bizLine,
    });
  },
  // 备注点击
  remarkMc(val) {
    mc('b_sailor_c_yexmvx1o_mc', {
      ...val,
      biz_line: bizLine,
    });
  },

  // 备注曝光
  remarkMv(val) {
    mv('b_sailor_c_yexmvx1o_mv', {
      ...val,
      biz_line: bizLine,
    });
  },
  // 编辑区域曝光
  editAreaMv() {
    mv('b_waimai_c_overseas_0qvzif09_mv', {
      status,
      biz_line: bizLine,
    });
  },

  // 显示更换地址的弹窗
  showUpdateAddressDialogMv(val) {
    mv('b_sailor_c_6ttj6jdc_mv', {
      ...val,
      biz_line: bizLine,
    });
  },
  // 保存更新地址
  saveAndUpdateAddressBtnMc() {
    mc('b_sailor_c_oltvmt9f_mc', {
      status,
      biz_line: bizLine,
    });
  },
  // 保存不更新地址
  saveAddressBtnMc() {
    mc('b_sailor_c_0ataq4rt_mc', {
      status,
      biz_line: bizLine,
    });
  },
  // 关闭弹窗
  closeAddressDialogMc(val) {
    mc('b_sailor_c_6ttj6jdc_mc', {
      ...val,
      biz_line: bizLine,
    });
  },
  // 修改按钮
  editPointMc() {
    mc('b_sailor_c_ikr82ghk_mc', {
      biz_line: bizLine,
    });
  },
  // 历史数据解构接口报错弹窗
  structErrorDialogMv(val) {
    mv('b_sailor_c_cz27mh3j_mv', {
      ...val,
      biz_line: bizLine,
    });
  },
  // 交付点点击
  markerMc(val) {
    mc('b_sailor_c_o3l7a99r_mc', {
      ...val,
      biz_line: bizLine,
    });
  },
  // 交付点曝光
  markerMv(val) {
    mv('b_sailor_c_o3l7a99r_mv', {
      ...val,
      biz_line: bizLine,
    });
  },
  // 结构化的详细地址曝光
  detailMv(val) {
    mv('b_sailor_c_0yayagx2_mv', {
      ...val,
      biz_line: bizLine,
    });
  },
  // 结构化的详细地址点击
  detailItemMc(val) {
    mc('b_sailor_c_0yayagx2_mc', {
      ...val,
      biz_line: bizLine,
    });
  },
  // zoom in
  zoomInMv(val) {
    mv('b_sailor_c_qghaperw_mv', {
      ...val,
      biz_line: bizLine,
    });
  },
  // zoom in
  zoomInMc(val) {
    mc('b_sailor_c_qghaperw_mc', {
      ...val,
      biz_line: bizLine,
    });
  },
  // 详细地址输入框点击
  addressDetailMc() {
    mc('b_sailor_c_37nojt3u_mc', {
      biz_line: bizLine,
    });
  },
  // 详细地址输入框曝光
  addressDetailMv() {
    mv('b_sailor_c_37nojt3u_mv', {
      biz_line: bizLine,
    });
  },
  // 点击切换城市的按钮
  changeCityMc() {
    mc('b_sailor_c_mh740emh_mc', {
      biz_line: bizLine,
    });
  },
  // 在地图上显示用户的位置
  onShowUserLocMv() {
    mv('b_sailor_c_uf40q1js_mv', {
      biz_line: bizLine,
    });
  },
  // 拍照和选择图片模块
  showCameraAndImageMv() {
    mv('b_sailor_c_g6qlqvjj_mv', {
      biz_line: bizLine,
    });
  },
  // 拍照和选择图片模块
  showCameraAndImageMc() {
    mc('b_sailor_c_g6qlqvjj_mc', {
      biz_line: bizLine,
    });
  },
  previewImagePopupMv() {
    mv('b_sailor_c_gi06ovka_mv', {
      biz_line: bizLine,
    });
  },
  previewImagePopupMc(val) {
    mc('b_sailor_c_gi06ovka_mc', {
      ...val,
      biz_line: bizLine,
    });
  },
  addressNameBubbleMv() {
    mv('b_sailor_c_5mdatfvy_mv', {
      biz_line: bizLine,
    });
  },
  addressNameBubbleMc(val) {
    mc('b_sailor_c_5mdatfvy_mc', {
      ...val,
      biz_line: bizLine,
    });
  },
  closeAddressNameBubbleMc() {
    mc('b_sailor_c_s5sb5xz8_mc', {
      biz_line: bizLine,
    });
  },
  addressPhoneBubbleMv() {
    mv('b_sailor_c_5lhvys8f_mv', {
      biz_line: bizLine,
    });
  },
  addressPhoneBubbleMc(val) {
    mc('b_sailor_c_5lhvys8f_mc', {
      ...val,
      biz_line: bizLine,
    });
  },
  closeAddressPhoneBubbleMc() {
    mc('b_sailor_c_slqp3p6l_mc', {
      biz_line: bizLine,
    });
  },
  permissionGuideViewMv(val) {
    mv('b_sailor_c_kkvelk2b_mv', {
      ...val,
      biz_line: bizLine,
    });
  },
  permissionGuideViewMc(val) {
    mc('b_sailor_c_kkvelk2b_mc', {
      ...val,
      biz_line: bizLine,
    });
  },
  saveReceiverAddressMv() {
    mv('b_sailor_c_vuxuc086_mv', {
      biz_line: bizLine,
    });
  },
  saveReceiverAddressMc() {
    mc('b_sailor_c_vuxuc086_mc', {
      biz_line: bizLine,
    });
  },
  confirmAddressButtonMv(val) {
    mv('b_sailor_c_eic2d2oc_mv', {
      ...val,
      biz_line: bizLine,
    });
  },
  confirmAddressButtonMc(val) {
    mc('b_sailor_c_eic2d2oc_mc', {
      ...val,
      biz_line: bizLine,
    });
  },
  // 地图编辑页-GCC国家详细地址填写模块
  addressEditMv() {
    mvNoDuplicateReport('b_sailor_c_89tlkuhq_mv', {
      page_type: pageType,
      address_type: addressType
    });
  },
  addressInputMv(jsonObj) {
    const newVal = flattenObject(jsonObj);
    mvNoDuplicateReport('b_sailor_c_49buz5nt_mv', {
      ...newVal,
      page_type: pageType,
      address_type: addressType
    });
  },
  addressInputMc(addressLabel, inputBoxName) {
    mc('b_sailor_c_49buz5nt_mc', {
      address_label: addressLabel,
      input_box_name: inputBoxName,
      page_type: pageType,
      address_type: addressType
    });
  },
  addressLabelMv(addressLabel) {
    mvNoDuplicateReport('b_sailor_c_ds0q8jsq_mv', {
      address_label: addressLabel,
      page_type: pageType,
      address_type: addressType
    });
  },
  addressLabelMc(addressLabel) {
    mc('b_sailor_c_ds0q8jsq_mc', {
      address_label: addressLabel,
      page_type: pageType,
      address_type: addressType
    });
  },
  // 保存按钮mv打点
  saveAddressMv(detailAddressType) {
    mvNoDuplicateReport('b_waimai_c_overseas_ovcfdoxo_mv', {
      detail_address_type: detailAddressType,
      biz_line: bizLine,
      page_type: pageType,
      address_type: addressType
    });
  },
  // 保存结果上报0 成功 1 失败
  saveAddressResultMv(val) {
    mv('b_sailor_c_x81xnzln_mv', {
      save_result: val
    });
  },
  firstInstallationBackMv(val) {
    mv('b_sailor_c_l7nfhgzs_mv', {
      ...val,
      biz_line: bizLine,
      page_type: pageType,
    });
  },
  firstInstallationBackMc(val) {
    mc('b_sailor_c_l7nfhgzs_mc', {
      ...val,
      biz_line: bizLine,
      page_type: pageType,
    });
  },
  firstInstallationSkipMv(val) {
    mv('b_sailor_c_m18yaesu_mv', {
      ...val,
      biz_line: bizLine,
      page_type: pageType,
    });
  },
  firstInstallationSkipMc(val) {
    mc('b_sailor_c_m18yaesu_mc', {
      ...val,
      biz_line: bizLine,
      page_type: pageType,
    });
  },
  outsideAreaMv(val) {
    mv('b_sailor_c_6cxragyj_mv', {
      ...val,
      biz_line: bizLine,
      page_type: pageType,
    });
  },
  outsideAreaMc(val) {
    mc('b_sailor_c_6cxragyj_mc', {
      ...val,
      biz_line: bizLine,
      page_type: pageType,
    });
  },
  // scene=changeAddress 专用：超距离、超区提示弹窗 MV
  changeAddressOutsideAreaMv() {
    Statistics?.view('c_waimai_c_overseas_dmr0kb7p', 'b_sailor_c_u80g617l_mv', {});
  },
  // scene=changeAddress 专用：超距离、超区提示弹窗按钮 MC
  changeAddressOutsideAreaMc(buttonName: string) {
    Statistics?.click(
      'c_waimai_c_overseas_dmr0kb7p',
      'b_sailor_c_5pgmeccn_mc',
      { button_name: buttonName }
    );
  },
  addressInputEditMc() {
    mc('b_sailor_c_eymevbk6_mc', {
      biz_line: bizLine,
    });
  },
  expandIconMC() {
    mc('b_sailor_c_72z01sxr_mc', {
      biz_line: bizLine,
    });
  },
  skipChangeMv(isCheck: boolean) {
    const val = { check_status: (isCheck ? 1 : 0) };
    mv('b_sailor_c_ac2imm02_mv', {
      ...val,
      biz_line: bizLine,
    });
  },
  skipChangeMc(isCheck: boolean, name: string) {
    let contentParam = 0;
    if (name === 'streetNumber') {
      contentParam = SKIP_NO_STREET_NUMBER;
    } else if (name === 'additionalDirection') {
      contentParam = SKIP_NO_ADDITIONAL;
    }
    const val = { check_status: (isCheck ? 1 : 0), content: contentParam, input_name: name };
    mc('b_sailor_c_ac2imm02_mc', {
      ...val,
      biz_line: bizLine,
    });
  },
  editMapMv() {
    mv('b_sailor_c_sede88vt_mv', {});
  },
  editMapMc() {
    mc('b_sailor_c_sede88vt_mc', {});
  },
  editDeleteMv() {
    mv('b_waimai_c_overseas_j6sepywn_mv', {
      common_text: 4,
      index: -999,
      type: 7,
    });
  },
  editDeleteMc() {
    mc('b_waimai_c_overseas_j6sepywn_mc', {
      common_text: 4,
      index: -999,
      type: 7,
    });
  },
  // nearby_address 接口返回后的 POI 数据上报
  nearbyAddressReturnMc(val) {
    mc('b_sailor_c_cq5qq4zt_mc', {
      ...val,
      biz_line: bizLine,
    });
  },
  // 开放地图确认按钮：上报吸附绿点来源类型（1=接口返回后吸附，2=点击绿点切换，3=使用freePoint）
  locatePointTypeMc(val) {
    mc('b_sailor_c_lpiw0zm9_mc', {
      ...val,
      biz_line: bizLine,
    });
  },
  // 平台引导图
  guidanceMv() {
    mv('b_sailor_c_ex6aw2gq_mv', {});
  },
  guidanceMc() {
    mc('b_sailor_c_ex6aw2gq_mc', {});
  },
  // 纠偏弹窗 mv
  correctionTipPopupMv() {
    mv('b_sailor_c_i1d9xo27_mv', {});
  },
  // 纠偏弹窗Close mc
  correctionTipPopupCloseMc() {
    mc('b_sailor_c_zhjm6qcd_mc', {
    });
  },
  // 纠偏弹窗Confirm mc
  correctionTipPopupConfirmMc(addressId?: any, selectedIndex?: any) {
    mc('b_sailor_c_p9cuadx5_mc', {
      address_id: addressId || '',
      address_type: selectedIndex || 0
    });
  }
};

export default lx;

/**
 * 上报保存地址时各字段的当前值与默认值（埋点 id 待补充）
 * @param params.schemaKeys schema 地区字段 key 列表（addressStructV2Ref 的 keys）
 * @param params.schemaCurrentValues schema 地区当前值 map（addressStructInfoV2）
 * @param params.schemaDefaultValues schema 地区默认值 map（defalutValues.addressStructInfoV2）
 * @param params.isHKStructRegion 是否是 HK 结构化地区
 * @param params.fieldCurrentValues 非 schema 地区当前字段值 map
 * @param params.fieldDefaultValues 非 schema 地区默认字段值 map
 * @param params.fieldNames 非 schema 地区字段 key 列表
 */
export function reportSaveAddressFieldChange(params: {
  schemaKeys: string[];
  schemaCurrentValues: { [key: string]: any; };
  schemaDefaultValues: { [key: string]: any; };
  fieldCurrentValues: { [key: string]: any; };
  fieldDefaultValues: { [key: string]: any; };
  fieldNames: string[];
  currentStructType: number;
}) {
  const {
    schemaKeys,
    schemaCurrentValues,
    schemaDefaultValues,
    fieldCurrentValues,
    fieldDefaultValues,
    fieldNames,
    currentStructType
  } = params;

  const region = SLCompass?.getCompassInfo?.()?.region || '';
  const label = currentStructType || '';
  let prefix = `${region}-`;
  if (label) {
    prefix += `${label}-`;
  }

  if (schemaKeys.length > 0) {
    // schema 地区（如 BR 等）
    schemaKeys.forEach((key) => {
      const currentValue = schemaCurrentValues[key];
      const defaultValue = schemaDefaultValues[key];
      const isChanged = currentValue !== defaultValue;
      mc('b_sailor_c_u513q2zj_mc', {
        address_description: prefix + key,
        is_auto_fill: defaultValue ? 1 : 0,
        is_same: isChanged ? 0 : 1,
        region_name: region,
      });
    });
  } else {
    // 非 schema 地区（HK / SA）
    fieldNames.forEach((key) => {
      const currentValue = fieldCurrentValues[key];
      const defaultValue = fieldDefaultValues[key];
      const isChanged = currentValue !== defaultValue;
      mc('b_sailor_c_u513q2zj_mc', {
        address_description: prefix + key,
        is_auto_fill: defaultValue ? 1 : 0,
        is_same: isChanged ? 0 : 1,
        region_name: region,
      });
    });
  }
}
